<!--
    编辑器：核心编辑窗口
    作用：提供字体、字号选择等下拉的菜单组件；
    实现：下拉菜单；
    组件：el-dropdown，对应dropData.js，familyData，fontSizeData
    注释：WJ
-->
<template>
    <div
            class="content-box"
            :class="{
                'type-show': newShowType,
                showQuestionBank: selectedType === 'questionBank'
            }"
            @mouseleave="isMove = false"
            @mouseup="isMove = false"
    >
        <div v-if="$route.query.dev">
            <p style="position: absolute; left: 300px;top: 0px;color: red;z-index: 999999999;">{{!!cocos_web && !!isShowContent}}</p>
            <p style="position: absolute; left: 350px;top: 0px;color: red;z-index: 999999999;">{{$store.state.isBuildCocos}}</p>
        </div>
        <!--<PPTStatus-->
            <!--v-if="pptData.length>0 && isEditPage"-->
            <!--:data.sync="pptData"-->
            <!--@flashPPT="flashPPTList()"-->
        <!--/>-->
        <WarnInfo />
        <PPTStatus2
            v-if="$store.state.isPPTUploadRate && !$store.state.initial"
            v-bind="pptConfig"
            :rate="$store.state.curPPTRate"
            @close="$store.state.isPPTUploadRate = false"
            @cancel="cancelPPT"
            @submit="submitOptPPT"
        />
        <div class="zhezhao" v-if="newZhezhao"></div>
        <div v-if="$store.state.initial && !isPreview" class="cocos warn">
            <div class="loading-go show">
                <div class="bg-box">
                    <div class="bg">
                        <span class="lujing"></span>
                        <span class="word">LOADING</span>
                    </div>
                    <p class="title">编辑器加载中，请耐心等待哦～</p>
                </div>
            </div>
        </div>
        <template v-else-if="formLength<=0 && !isPreview">
            <div class="cocos warn">
                <div class="center-area">
                    <img :src="$images.global.empty" alt="" style="width: 120px;height:115px;" />
                    <span class="add theme-btn-active" @click.stop="handlerAdd">新增课件</span>
                </div>
            </div>
        </template>
        <!--<div-->
            <!--v-if="isSaving"-->
            <!--class="youxi-goujian"-->
            <!--:class="{-->
                <!--show: isSaving,-->
                <!--showType: showType-->
            <!--}"-->
        <!--&gt;-->
            <!--<span class="word">-->
                <!--<span class="iconfont icon-jiazai"></span>-->
                <!--<span class="txt">内容保存中,请稍后</span>-->
            <!--</span>-->
        <!--</div>-->
        <div
            v-if="$store.state.isBuildCocos && $route.name.indexOf('main')>-1"
            class="youxi-goujian game-cocos"
            :class="{
                show: isCocosBuiding,
                showType: showType,
                initial: $store.state.initial || !$store.state.menusData.blocksForm
            }"
        >
            <span class="word">
                <span class="iconfont icon-jiazai"></span>
                <span class="txt">构建初始化,请稍后</span>
            </span>
        </div>
        <div
            class="cocos"
            :class="{
                isHide: formLength<=0 && !isPreview,
                load: $store.state.initial && $store.state.menusData.blocksForm
            }"
            v-on:click="handleMouseEnterOpen"
        >
            <div v-if="!isPreview" class="loading-go"
                 :class="{show: $store.state.initial && $store.state.menusData.blocksForm}">
                <div class="bg-box">
                    <div class="bg">
                        <span class="lujing"></span>
                        <span class="word">LOADING</span>
                    </div>
                    <p class="title">编辑器加载中，请耐心等待哦～</p>
                </div>
            </div>
            <div
                v-if="cocos_web"
                ref="cocos_web"
                class="cocos_web"
                :class="{
                    game: (menusData.lessonSelectedConfig && menusData.lessonSelectedConfig.type === 'game') && $route.name === 'main',
                    isNone: !$store.state.editGameConfig,
                    ppt: isEditPPTShow
                }"
                :style="
                    (menusData.lessonSelectedConfig && menusData.lessonSelectedConfig.type === 'game') &&
                    $route.name === 'main' &&
                    (cocosHeight?cocosHeight:newWidth && `width: ${newWidth}px !important;height: ${newHeight}px !important;`)
                "
            >
                <div :class="{disabled: realDisabled}"></div>
                <div v-if="isMove" class="zhezhao"></div>
                <iframe
                        v-if="type!=='guide' && isShowContent"
                        allow="autoplay"
                        id="iframe"
                        ref="iframe_cocos"
                        class="iframe-cocos"
                        :src="isOnceLoad && cocos_web"
                        frameborder="0">
                </iframe>

                <!--<p class="zhezhao-left" :style="`width: ${zhezhaoWidth}px;`"></p>-->
                <!--<p class="zhezhao-right" :style="`width: ${zhezhaoWidth}px;`"></p>-->
               <!-- <el-button v-if="showRefresh" class="refresh-btn" icon="el-icon-refresh" @click="handleRefresh">重载</el-button> -->
            </div>
            <EditGame
                v-if="$route.name === 'main' &&
                        isCocos &&
                        (menusData.lessonSelectedConfig && menusData.lessonSelectedConfig.type === 'game')
                    "
                ref="editGame"
                :isMove.sync="isMove"
                :height.sync="editHeight"
            />
            <VoiceChange
                ref="voice"
                v-if="isVoiceChange"
                :isShow.sync="isVoiceChange"
                :form.sync="voiceConfig"
            />
        </div>

        <!--富文本编辑-->
        <EditContent
            v-if="isEditContent"
            :visible.sync="isEditContent"
            :value.sync="htmlContent"
            @onEditContent="onEditContent"
        />
    </div>
</template>

<script>
    import EditContent from '../../../../components/EditContent'
    import EditGame from './components/editGame'
    // import PPTStatus from './components/pptUploadStatus'
    import PPTStatus2 from './components/pptUploadStatus2'
    import WarnInfo from './components/warnInfo'
    import Config from '../../../../config/app'
    import * as GlobalServer from '../../../../api/global'
    import * as ResultServer from '../../../../api/result'
    import {mapState, mapActions} from 'vuex'
    export default {
        name: "contents",
        components: {
            EditContent,
            EditGame,
            // PPTStatus,
            PPTStatus2,
            WarnInfo
        },
        props: {
            type: String,
            isOnceLoad: {
                type: Boolean,
                default: true
            },
            zhezhao: {
                type: Boolean,
                default: false
            },
            isPractice: {
                type: Boolean,
                default: false
            },
            isPreview: {
                type: Boolean,
                default: false
            },
            showType: {
                type: Boolean,
                default: false
            },
            showMenu: {
                type: Boolean,
                default: false
            },
            width: {
                type: String
            },
            height: {
                type: String
            },
            // 类型选择
            selectedType: {
                type: String
            },
            formLength: [Number, String], // 当前课件总数
            gameSceneProxy:{
               type: String,
               default:null 
            },
            version:{
               type: String,
               default:'' 
            }
        },
        watch: {
            isBuildingOrSaving(vl){
                clearTimeout(this.fnBuildOrSave)
                this.fnBuildOrSave = setTimeout(()=>{
                    this.isBuildOrSave = vl
                    clearTimeout(this.fnBuildOrSave)
                }, 300)
            },
            disabled(vl){
                clearTimeout(this.disabledFn)
                if(vl){
                    this.realDisabled = vl
                }
                this.disabledFn = setTimeout(()=>{
                    this.realDisabled = vl
                    clearTimeout(this.disabledFn)
                }, 300)
            },
            isEditContent(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isEditContent', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isEditContent', value: true})
                }
            },
            width(vl){this.newWidth = vl},
            newWidth(vl){this.$emit('update:width',vl)},
            height(vl){this.newHeight = vl},
            newHeight(vl){this.$emit('update:height',vl)},
            showType(vl){this.newShowType = vl},
            newShowType(vl){this.$emit('update:showType',vl)},
            zhezhao(vl){this.newZhezhao = vl},
            newZhezhao(vl){this.$emit('update:zhezhao',vl)},
            isCalcContent:{
                handler(vl) {
                    //console.log('888==>', vl)
                    // debugger
                    if(vl) {
                        this.calcContent()
                    }
                },
                deep: true,
                immediate: true
            },
            '$store.state.curCocosDevUrl': {
                handler(){
                    this.init()
                },
                deep: true,
                immediate: false
            }
        },
        computed:{
            ...mapState([
                'pptData',
                'tempInsertPPTConfig',
                'isCocosSaving',
                'menusData',
                'menusDataIds'
            ]),
            isBuildingOrSaving(){
                return this.isCocosBuiding || this.isSaving
            },
            // 编辑游戏时，游戏区高度
            cocosHeight(){
                return this.menusData.lessonSelectedConfig?.type === 'game' && this.$route.name === 'main'?`height: ${this.contentHeight}px !important;`:';'
            },
            source(){
                // source 1 我的课件 2 我的模板 3 公共模板 4 游戏练习
                let newSource = 1
                if(`${this.$route.query.is_practice}` === 'true'){
                    newSource = 4
                } else if(`${this.$route.query.is_template}` === 'true'){
                    newSource = 2
                    if(`${this.$route.query.is_shop}` === 'true') newSource = 3
                }
                return newSource
            },
            // 当前是否编辑页面
            isEditPage(){
                return this.$route.path === '/main'
            },
            // 游戏是否正在构建
            isCocosBuiding(){
                return this.$store.state.isBuildCocos && this.isHasNav
            },
            // 菜单是否正在保存
            isSaving(){
                return  !this.$store.state.initial && this.$store.state.isCocosSaving
                // return  this.$store.state.saving
            },
            isBuildCocos(){
                return this.$store.state.isBuildCocos
            },
            // 当前是否有导航
            isHasNav(){
                let state = false
                try {
                    state = this.$store.state.menusData.blocksForm.length>0

                    // 如果是非编辑状态，不需要判断是否有导航
                    if(this.$route.path !== '/main'){
                        state = false
                    }
                }catch (e) {
                    console.log('当前是否有导航失败==>', e)
                }
                return state
            },
            isCalcContent(){
                return this.isShowContent && this.cocos_web && this.$route.path === '/preview'
            },
            isShowContent(){
                return this.$store.state.menusData &&
                    this.$store.state.menusData.blocksForm
            },
            isEditGameShow(){
                return this.menusData.lessonSelectedConfig?.type === 'game' && this.$route.name === 'main'
            },
            isEditPPTShow(){
                return this.menusData.lessonSelectedConfig?.type === 'html' && this.$route.name === 'main'
            },
            contentHeight(){
                let h = document.body.clientHeight
                return h - this.editHeight - 54
            },
            // isHasPage(){
            //   let state = false
            //     try {
            //         if(this.isCocosSaving) return false
            //         console.warn('优化速度==>isHasPage')
            //         const data = this.$store.state.menusData.blocksForm
            //         const unique = this.$store.state.menusData.blocksSelected
            //         const node = this.$utils.curSelectedNode({
            //             data,
            //             unique
            //         })
            //         console.log('7788==>', node, this.$store.state.menusData.blocksForm, this.$store.state.menusData.blocksSelected)
            //         if (node && node.children && node.children.length > 0) state = true
            //     }catch (e) {
            //         console.log('等待获取当前课程页数==>', e)
            //     }
            //   return state
            // },
            canvasWidth(){
                return this.showType && this.showMenu?64:75
            },
            scaleRate(){
                return this.showType && this.showMenu?'.42':'.48'
            },
            // zhezhaoWidth(){
            //     let width = 0
            //     try {
            //         let div = document.querySelector('.cocos')
            //         let offHeight = div.offsetHeight
            //         let offWidth = div.offsetWidth
            //         let cocosWidth = offHeight * 16 / 9
            //         width = Math.abs((offWidth - cocosWidth) / 2) + 14
            //     } catch (e) {
            //         console.log('获取遮照两边宽度失败==>', e)
            //     }
            //     return width
            // },
        },
        created() {
            window.__web_vue__ = this
            window.cocos_web = this.changeCocosWeb
            this.init()
            // 监听cocos区是否禁用
            this.$nextTick(()=>{
                $eventBus.$on('onCocosDisabled', this.onCocosDisabled)
            setTimeout(()=>{
                    this.showRefresh = true
                },800)
            })
        },
        mounted(){
            this.$nextTick(async ()=>{
                this.clacZhezhaoWidth()
                window.onresize = () => {
                    let fn = setTimeout(()=>{
                        this.clacZhezhaoWidth()
                        clearTimeout(fn)
                    }, 200)
                }

                // 如果当前是编辑页面 获取ppt导入历史记录
                this.flashPPTList()
            })
            
            setInterval(()=>{
                if (document.activeElement === document.getElementById("iframe")) {
                    this.$store.state.menusKeyBoard=false;
                }
            },100);
        },
        data(){
            return {
                isBuildOrSave: false, // 当前是否正在构建cocos或保存配置
                fnBuildOrSave: null, //  构建或保存事件
                newWidth: this.width,
                newHeight: this.height,
                isCocos: true, // 给cocos 手动切换
                isVoiceChange: false, // 背景音
                voiceConfig: {}, // 背景音配置

                editHeight: 310, // 编辑区高度
                isMove: false,
                disabledFn: null, // 禁用事件
                disabled: false, // cocos区是否禁用
                realDisabled: false, // 真正禁用

                zhezhaoWidth: 0,
                newZhezhao: this.zhezhao,
                cocos_web: this.$store.state.cocos_local || Config.cocos_web,
                num: 100,
                playTime: '00：15/00：18',
                newShowType: this.showType,
                // 是否正在播放
                isPlay: false,

                // 是否编辑
                isEditContent: false,
                htmlContent: {type: 'word', value: ''},

                // ppt弹窗信息
                pptConfig: {
                    title: '',
                    content: '',
                    cancelName: '',
                    submitName: ''
                },
                showRefresh:false

                // pptData: [
                //     {id: 1, name: 'ppt上传文件名称1', status: 'success'},
                //     {id: 2, name: 'ppt上传文件名称2', status: 'success'},
                // ]
            }
        },
        methods:{
            ...mapActions([
                'cancelSelectMenu',
                'setPPTData',
                'setTempInsertPPTConfig',
                'setSendKeyBoardToCocos'
            ]),
            async init(){
                try {
                    let url = ''
                    let server = 'yunkeduntest'
                    if(Config.domain === 'yunkedun.com'){
                        server = 'yunkedun'
                    }
                    if(this.$store.state.curCocosDevUrl){
                        url = this.$store.state.curCocosDevUrl
                    }else if(this.version){
                        const res = await GlobalServer.getCocosPackList({versionOrder: 'desc',version:this.version})
                        //console.log('版本地址', res.items[0].attach.unpack_url)
                        url = res.items[0].attach.unpack_url
                    }else{
                        const res = await GlobalServer.getPackLast()
                        //console.log('最新地址', res.data.attach.unpack_url)
                        url = res.data.attach.unpack_url
                    }

                    if(Config.isDev)url = url.replace('https','http')
                    //console.log("开始：3",this.$route.query);
                    let lessonSelected=(this.$route.query.t=="1")?"":`&t=edit&lessonSelected=${this.$store.state.menusData.lessonSelected}`;
                    if(this.$route.path.indexOf('preview')>-1 && this.isPractice){
                        url+= `?scene=ykdkhlx&platform=vue&server=${server}`
                        // 如果是编辑过来，需要带上默认选中菜单参数
                        if(`${this.$route.query.isEdit}` === 'true') url+=lessonSelected
                    }
                    // 如果是预览地址，加上后缀 ?scene=preview&platform=h5
                    else if(this.isPreview){
                        url+= `?scene=preview&platform=vue&server=${server}`
                        // 如果是编辑过来，需要带上默认选中菜单参数
                        if(`${this.$route.query.isEdit}` === 'true') url+=lessonSelected
                    }
                    // 判断如果参数不存在server,加上
                    if(url.indexOf('server') === -1){
                        if(url.indexOf('?') === -1){
                            url+=`?server=${server}`
                        }else {
                            url+=`&server=${server}`
                        }
                    }
                    const resultUrl = this.$store.state.cocos_local || url
                    const resultUrlDev = `${resultUrl}&gameSceneProxy=${this.gameSceneProxy}`
                    if(Config.domain === 'yunkedun.com'){
                       this.cocos_web = resultUrl
                       return
                    }else{
                        this.cocos_web = this.gameSceneProxy ? resultUrlDev : resultUrl
                    }

                    
                }catch (e) {
                    console.log('获取预览地址失败==>', e)
                }
            },       
            // 新建课件
            handlerAdd(){
                const {saving,isBuildCocos,isCocosSaving} = this.$store.state
                if(saving || isBuildCocos || isCocosSaving){
                    return false
                }

                this.$emit('addPage')
            },
            // 监听cocos区是否禁用 [预览素材防止cocos拿走焦点]
            onCocosDisabled(state){
                this.disabled = state
            },
            // 取消PPT
            cancelPPT(){
                // 1.向服务端通知取消导入PPT
                // 2.关闭弹窗
                // 3.更新ppt历史记录列表
                console.log('取消PPT==>')
                this.cancelSelectMenu((opted)=>{
                    if(opted && opted.status_code === 200) {
                        this.$store.state.isPPTUploadRate = false
                        this.flashPPTList()
                        this.$message.success('取消成功')
                    } else {
                        this.$message.error('取消失败')
                    }
                })
            },
            // 插入PPT或者选中菜单后插入PPT
            submitOptPPT(){
                this.$store.state.isPPTUploadRate = false

                // 如果当前存在标记过的flag,并且菜单目录还存在，或者菜单还存在 ppt直接插入到对应位置
                const pptConfig = this.tempInsertPPTConfig
                // console.log(pptConfig)
                // debugger
                const flag = flag && typeof pptConfig.flag === 'string'? JSON.parse(pptConfig.flag) : pptConfig.flag
                if(flag && flag.type){
                    switch (flag.type) {
                        case 'leaf': {
                            // 获取当前菜单节点
                            console.log('优化速度==>leaf')
                            const leafNode = this.$utils.getObjByCurLesson({
                                data: this.$store.state.menusData.blocksForm,
                                node: flag.unique,
                                type: 'select'
                            })
                            if(leafNode && leafNode.parentUnique){

                                let index = 0
                                let catalogNode =  this.$utils.curSelectedNode({
                                    data: this.$store.state.menusData.blocksForm,
                                    unique: leafNode.parentUnique})
                                if(catalogNode && catalogNode.children.length){
                                    catalogNode.children.map((v,i)=>{
                                        if(`${v.unique}` === `${flag.unique}`) {
                                            index = i
                                        }
                                    })
                                }

                                // 将PPT插入当前目录下中的菜单下
                                this.$emit('insertPPT',{
                                    resources_id: pptConfig.data.id,
                                    status: 2,
                                    h5_remote: pptConfig.data.attributes.h5_dir,
                                    limit: pptConfig.data.attributes.limit,
                                    index,
                                    cocos_dir: pptConfig.data.attributes.cocos_dir,
                                    static_id: pptConfig.data.attributes.id
                                })
                                return false
                            }
                            break
                        }
                        case 'catalog': {
                            // 获取菜单目录节点
                            const catalogNode = this.$utils.curSelectedNode({
                                data: this.$store.state.menusData.blocksForm,
                                node: flag.unique
                            })
                            if(catalogNode && catalogNode.unique){
                                // 将PPT插入当前目录下下
                                this.$emit('insertPPT',{
                                    resources_id: pptConfig.data.id,
                                    status: 2,
                                    h5_remote: pptConfig.data.attributes.h5_dir,
                                    limit: pptConfig.data.attributes.limit,
                                    cocos_dir: pptConfig.data.attributes.cocos_dir,
                                    static_id: pptConfig.data.attributes.id
                                })
                                return false
                            }
                            break
                        }
                    }
                }

                console.log('插入PPT==>2')
                this.$store.state.is_global_select_menu = true
            },
            // 刷新ppt历史记录列表
            async flashPPTList(type){
                // 如果当前是编辑页面 获取ppt导入历史记录
                const id = this.$route.query.practice_id || this.$route.query.id
                if(this.isEditPage && id ){
                    const clientsId = this.$store.state.initConfig.school_id>0?this.$store.state.initConfig.school_id:0
                    const res = await ResultServer.getPPTList({
                        clientsId,
                        id,
                        source: this.source
                    })
                    if(res && res.status_code === 200) {
                        let newArr =  res.data && res.data.resources || []
                        newArr = newArr.map(v=>{
                            return {
                                id: v.id,
                                name: v.name,
                                status: v.attributes && v.attributes.status,
                                flag: v.attributes.options,
                                attributes: v.attributes
                            }
                        })
                        this.setPPTData(newArr)

                        // 上传ppt过程中存更新ppt记录列表
                        if(type === 'only') return false

                        // TODO 如果当前ppt列表存在转换成功，但没插入前端页面时 status=1
                        // 提示是否要插入页面或取消
                        let cur = {}
                        newArr.map(v=>{
                            if(`${v.status}` === '1') cur = v
                        })
                        if(cur && cur.id) {
                            // flag {type: 'leaf', unique: xxx} leaf表示最后一片叶子 catalog表示是否为目录
                            let flag = cur.flag
                            if(flag && flag !== void 0){
                                flag = JSON.parse(flag)
                            }
                            this.setTempInsertPPTConfig({
                                data: cur,
                                id: this.$route.query.id,
                                source: this.source,
                                flag
                            })
                            if(flag && flag.type) {
                                this.pptConfig = {
                                    title: '提示',
                                    content: 'PPT转换完成，是否插入PPT',
                                    cancelName: '取 消',
                                    submitName: '确 认'
                                }
                            }else {
                                this.pptConfig = {
                                    title: '提示',
                                    content: 'PPT转换完成，请选择要插入的页面',
                                    cancelName: '取消插入',
                                    submitName: '选择页面'
                                }
                            }
                            this.$store.state.isPPTUploadRate = true
                        }
                    }
                }
            },
            // 编辑背景音
            setVoiceConifg({data}){
                console.log('setVoiceConifg==>', data)
                const newData = data.value
                this.isVoiceChange = newData.isShow
                this.voiceConfig = {
                    index: data.index,
                    name: '',
                    isShow: false,
                    isBackground: false,
                    displayTime: 0,
                    curTime: 0,
                    allTime: 0,
                    playTime: 0,
                    play: false,
                    url: '',
                    volume: 50, // 音量
                    ...newData
                }
            },
            // 计算遮挡块宽度
            clacZhezhaoWidth(){
                if(this.$route.path === '/preview') {
                    try {
                        let div = document.querySelector('.cocos')
                        let offHeight = div.offsetHeight
                        let offWidth = div.offsetWidth
                        let cocosWidth = Math.floor(offHeight * 16 / 9)
                        this.zhezhaoWidth = Math.abs((offWidth - cocosWidth) / 2)

                        // 如果宽比高还小，不必要遮挡
                        if(offWidth / offHeight <= 16 / 9) {
                            this.zhezhaoWidth = 0
                        }

                        // 展示区始终呈现 16：9
                        if(this.isCalcContent) {
                            this.calcContent()
                        }

                    } catch (e) {
                        console.log('获取遮照两边宽度失败==>', e)
                    }
                }
            },
            // 时刻保持 预览内容区比例为16:9
            calcContent(){
                this.$nextTick(()=>{
                    // let body = document.body
                    let cocos = document.querySelector('.cocos')
                    let cocos_web = document.querySelector('.cocos_web')
                    // console.log(cocos_web)
                    // debugger
                    // let cocosWidth = cocos_web.clientWidth
                    let cocosHeight = cocos.clientHeight
                    let newWidth = cocosHeight / 9 * 16
                    cocos_web.style.width =  newWidth + 'px'

                    // 如果宽比可视区域的宽还大，则缩放宽和高
                    // if(body.clientWidth < newWidth + 296){
                        cocos_web.style.width = newWidth + 'px'
                        cocos_web.style.height = cocosHeight + 'px'
                    // }
                })
            },
            changeCocosWeb(url){
                // location.href = (location.href + '&token=' + localStorage.getItem('im-edit-token')).replace('https','http')
                this.cocos_web = ''
                this.$refs.editGame && this.$refs.editGame.clearHighLight()
                setTimeout(()=>{
                    this.$store.state.cocos_local = url
                    this.cocos_web =  url
                },200)
            },
            // 编辑
            handleEdit(data){
                // 获取当前备注信息
                if(!this.$store.state.menusData.lessonSelected){
                    this.$message.error('请选选择课程')
                    return false
                }
                // 保持cocos传来的索引
                if(data.index>-1)this.index = data.index
                console.log('优化速度==>handleEdit')
                const curItem = this.menusDataIds[this.menusData.lessonSelected] // this.$utils.getObjByCurLesson({})
                if(!curItem){
                    this.$message.error('请选选择课程')
                    return false
                }
                let defaultObj = {value: '', type: 'word'}
                let obj = !Array.isArray(curItem.remark)? (curItem.remark?curItem.remark:defaultObj): defaultObj
                let newContent = obj
                this.htmlContent = newContent
                this.isEditContent = true
            },
            // 富文本内容
            onEditContent(text){
                // TODO 富文本图片上传换成腾讯云
                console.log('富文本==>', text)
                this.htmlContent = text
                // 将当前编辑的课程设置备注
                console.log('优化速度==>onEditContent')
                const node = this.menusDataIds[this.menusData.lessonSelected] //this.$utils.getObjByCurLesson({})
                node.remark = text
                // this.$emit('save', true)
                console.log('获取当前最新配置==>', this.$store.state.menusData)

                // 向cocos发出当前配置
                let obj = {type: 'EditNote', value: node.remark}
                if(this.index>-1) obj.index = this.index
                this.$toCocosMessage(obj)
            },
            // 播放
            handleBofang(){
                this.isPlay = !this.isPlay
            },
            // 加减缩放
            handleContralSize(boolean){
                let value = this.num
                if(boolean){
                    value = value + 25
                }else{
                    value = value - 25
                }
                if(value<=50){
                    value = 50
                }
                if(value>=100) {
                    value = 100
                }
                this.num = value
            },
            // 清除弹窗状态
            flushStatus(){
                this.pptConfig = {
                    title: '',
                    content: '',
                    cancelName: '',
                    submitName: ''
            }
        },
        handleMouseEnterOpen(){
            this.$store.state.menusKeyBoard=false;//当前是不可操作焦点
        },
         handleRefresh(){
             let time = Date.parse( new Date() ).toString();//获取到毫秒的时间戳，精确到毫秒
             time = time.substr(0,10);//精确到秒
             console.log('tiem', time)
            // location.reload()
        },
        },
        destroyed(){
            this.$store.state.isPPTUploadRate = false
            $eventBus.$off('onCocosDisabled')
        },
    }
</script>

<style lang="scss" scoped>
.content-box{
    display: flex;
    flex-direction: column;
    flex: 1;
    /*background-color: #F7F7F7;*/
    /*padding: 0px 80px;*/
    /*padding-left: 80px;*/
    transition: all .2s linear;
    position: relative;
    /*height: 100vh;*/
    top: 1px;

    .youxi-goujian{
        display: flex;
        position: absolute;
        left: 0px;
        top: 0px;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        z-index: 99;

        &.game-cocos{
            z-index: 98;

            &.initial{
                z-index: 95;
            }
        }

        &.showType .word{
            margin-right: 300px;
        }

        .word{
            width: 158px;
            height: 70px;
            background: rgba(255,255,255,1);
            box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
            border-radius: 8px;
            font-size: 14px;
            color: rgba(48,49,51,1);
            line-height: 20px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;

            .iconfont {
                font-size: 30px;
                margin-top: 12px;
                margin-bottom: 8px;
                transition: all .2s linear;
                animation: loop1  2s infinite;;
            }
            @keyframes loop1 {
                0% {
                    transform: rotateZ(0deg);
                }
                100% {
                    transform: rotateZ(360deg);
                }
            }

        }
    }

    .zhezhao{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 999999;
        /*background-color: #fed800;*/
    }

    &.type-show{
        padding: 0px;
        padding-right: 300px;
        // height: 100vh;
        position: relative;
        // top: -54px;
    }

    &.type-show.showQuestionBank{
        padding-right: 443px;
    }

    .opt{
        display: flex;
        flex-direction: row;
        margin-top: 18px;

        .btn{
            cursor: pointer;
            margin-right: 15px;
            background-color: white;
            border: 1px solid #f1f1f1;
            border-radius: 6px;
            padding: 2px 10px;
            position: relative;
            left: -2px;

            .iconfont{
                font-size: 16px;
            }
        }
        .btn:active{
            background-color: #fed800;
        }
    }
    .cocos_web{
        /*height: calc(100vh - 54px - 608px);*/
        height: 100%;
        width: 100%;
        overflow: hidden;
        position: relative;

        &.build{
            visibility: hidden;
        }

        .disabled{
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: rgba(0,0,0,0);
            width: 100%;
            height: 100%;
            z-index: 102;
        }

        .zhezhao{
            position: absolute;
            top: 0px;
            left: 0px;
            /*background-color: wheat;*/
            width: 100%;
            height: 100%;
            z-index: 101;
        }
        &.game{
            height: calc(100vh - 54px - 318px);
        }
        &.isNone{
            height: 100% !important;
        }
        &.ppt{
            width: calc(100% - 60px) !important;
            height: calc(100% - 62px) !important;
            border-top: 50px solid #E8E9F1;
            border-bottom: 12px solid #E8E9F1;
            border-left: 30px solid #E8E9F1;
            border-right: 30px solid #E8E9F1;
        }


        .zhezhao-left{
            position: absolute;
            top: 0px;
            left: 0px;
            width: 50px;
            height: 100%;
            background-color: #fff;

            &:before {
                position: absolute;
                content: '';
                width: 100%;
                height: 100%;
                top: 0px;
                left: 0px;
                /*background: url("../../../../assets/images/resource/material/shuiyin.png") repeat;*/
            }
        }

        .zhezhao-right{
            position: absolute;
            top: 0px;
            right: 0px;
            width: 50px;
            height: 100%;
            background-color: #fff;

            &:before {
                position: absolute;
                content: '';
                width: 100%;
                height: 100%;
                top: 0px;
                left: 0px;
                /*background: url("../../../../assets/images/resource/material/shuiyin.png") repeat;*/
            }
        }

        .iframe-cocos{
            width: 100%;
            height: 100%;
        }
    }
    .cocos{
        /*margin-top: 30px;*/
        /*height: calc(100vh - 115px);*/
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        position: relative;
        justify-content: center;
        z-index: 97;

        &.load{
            z-index: 100;
        }

        .loading-go{
            background-color: white;
            position: absolute;
            left: 0px;
            top: 0px;
            /*top: 55px;*/
            width: 100%;
            height: 100%;
            /*height: calc(100% - 55px);*/
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10001;
            opacity: 0;
            z-index: -100;
            transition: all .2s linear;

            &.show{
                opacity: 1;
                z-index: 10001;
            }

            .bg-box{
                display: flex;
                flex-direction: column;
                align-items: center;

                .bg{
                    width: 116px;
                    height: 116px;
                    background-color: white;
                    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.15);
                    border-radius: 50%;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    position: relative;

                    .lujing{
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        width: 100%;
                        height: 100%;
                        background: url("../../../../assets/images/resource/material/lujing.png") no-repeat;
                        transition: all .2s linear;
                        animation: loop  2s infinite;;
                    }

                    @keyframes loop {
                        0% {
                            transform: rotateZ(0deg);
                        }
                        100% {
                            transform: rotateZ(360deg);
                        }
                    }

                    .word {
                        font-size:16px;
                        font-weight:600;
                        color:rgba(255, 120, 56,1);
                        line-height:30px;
                    }
                }
                .title{
                    font-size:18px;
                    font-weight:400;
                    color:rgba(144,147,153,1);
                    line-height:25px;
                    margin-top: 24px;
                }
            }
        }

        .tishiyu{
            position: absolute;
            display: flex;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
            opacity: 0;
            z-index: -100;
            transition: all .5s linear;

            &.show{
                opacity: 1;
                z-index: 1000;
            }

            .word{
                width: 158px;
                height: 70px;
                background: rgba(255,255,255,1);
                box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
                border-radius: 8px;
                font-size: 14px;
                color: rgba(48,49,51,1);
                line-height: 20px;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;

                .iconfont {
                    font-size: 30px;
                    margin-top: 12px;
                    margin-bottom: 8px;
                    transition: all .2s linear;
                    animation: loop  2s infinite;;
                }
                @keyframes loop {
                    0% {
                        transform: rotateZ(0deg);
                    }
                    100% {
                        transform: rotateZ(360deg);
                    }
                }
            }
        }

        &.warn {
            color: gray;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;

            .center-area{
                display: flex;
                flex-direction: column;
                background-color: white;
                align-items: center;
                justify-content: center;
                border: 2px dotted #D0D2DD;

                width: calc(100% - 60px);
                height: calc(100% - 62px);
                margin: 50px 30px 12px;
            }

            .word {
                font-size:14px;
                color:rgba(48,49,51,1);
                line-height:20px;
                position: relative;
            }
            .add{
                margin-top: 34px;
                position: relative;
                left: 0px;
                width:88px;
                height:34px;
                line-height:34px;
                background:rgba(255, 120, 56,1);
                border-radius:4px;
                font-size:14px;
                color:rgba(255,255,255,1);
                text-align: center;
                cursor: pointer;

                &:active {
                    opacity: .8;
                }
            }
        }
        &.isHide{
            width: 0px;
            height: 0px;
            overflow: hidden;
        }

        &>img{
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    .control-size{
        display: flex;
        flex-direction: column;

        .switch {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;
            left: -6px;
            margin-top: 5px;

            .btn {
                cursor: pointer;
                width: 43px;
                height: 43px;
            }

            .num {
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                line-height: 43px;
                margin: 0px 10px;
            }
        }
        .control-time{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .btn{
                cursor: pointer;
                width: 25px;
                height: 26px;
                object-fit: contain;
            }
            .time{
                margin-left: 10px;
            }
        }
    }
}
.refresh-btn{
    position: fixed;
    right: 10px;
    bottom: 60px;
    padding: 9px 25px;
    font-size: 12px;
}
</style>
